export const SMTP_COMFIG_URLS = {
  SUBMIT_SMTP: '/admin/mail/verify-smtp',
  GET_SMTP: '/admin/mail/verify-smtp'
};
